module.exports = __webpack_public_path__ + "static/forecast/windstock/calm-6cf4d2e29f003b1ea29c75a150c34b6b.svg";